import { createContext, ReactNode, useContext, useState } from "react";

interface ProfileDropdownContextValue {
  isOpen: boolean;
  toggleProfileDropdown: () => void;
  closeDropdown: () => void;
}
const ProfileDropdownContext = createContext<ProfileDropdownContextValue | undefined>(undefined);

function TogglProfileDropdownProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleProfileDropdown = () => {
    setIsOpen((prev) => !prev);
  }

  const closeDropdown = () => {
    setIsOpen(false);
  }

  return (
    <ProfileDropdownContext.Provider value={{ isOpen, toggleProfileDropdown, closeDropdown }}>
      {children}
    </ProfileDropdownContext.Provider>
  );
}

function useProfileDropdown() {
  const context = useContext(ProfileDropdownContext);
  if (context === undefined)
    throw new Error("DarkModeContext was used outside of DarkModeProvider");
  return context;
}

export { TogglProfileDropdownProvider, useProfileDropdown };